import React from 'react';

const playButtonIcon = React.createElement("svg", { width: "22", height: "23", viewBox: "0 0 22 23", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("g", { id: "Frame 5801" },
        React.createElement("path", { id: "Rectangle 1974", d: "M5.5 4.91806C5.5 3.73442 6.80673 3.0171 7.80531 3.65256L18.6364 10.5451C19.5626 11.1345 19.5626 12.4866 18.6364 13.076L7.80531 19.9685C6.80673 20.604 5.5 19.8867 5.5 18.703V4.91806Z", fill: "white" })));

export { playButtonIcon };
//# sourceMappingURL=play_button_icon.js.map
